import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function initStackingCardsParallax() {
    const mm = gsap.matchMedia()

    mm.add('(min-width: 1025px)', () => {
        console.log('initStackingCardsParallax (>=1025px)')

        const cards = document.querySelectorAll('[data-stacking-cards-item]')
        if (cards.length < 2) return

        cards.forEach((card, i) => {
            // Skip over the first section
            if (i === 0) return

            // When current section is in view, target the PREVIOUS one
            const previousCard = cards[i - 1]
            if (!previousCard) return

            gsap.timeline({
                defaults: { ease: 'none', duration: 1 },
                scrollTrigger: {
                    trigger: card,
                    start: 'top bottom',
                    end: 'top top',
                    scrub: true,
                    invalidateOnRefresh: true
                    // markers: true
                }
            })
                .fromTo(previousCard, { yPercent: 0 }, { yPercent: 50 })
                .fromTo(
                    previousCard,
                    { opacity: 1 },
                    { opacity: 0, duration: 0.8 },
                    '<'
                )
        })

        // cleanup wanneer matchMedia de query verlaat
        return () => {}
    })

    return mm
}

// Initialize Stacking Cards Parallax
document.addEventListener('DOMContentLoaded', () => {
    const mm = initStackingCardsParallax()

    // optioneel: als je ooit deze module "unmount" wil doen
    // window.addEventListener('beforeunload', () => mm?.revert())
})
